export enum ArrowTone {
  LINE = 'line',
  ACCENT = 'accent',
  MUTED = 'muted',
}
